import axios from 'axios';

import { BASE_URL } from './Constants';

const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export async function saveFile(uidFile, file) {
  try {
    const response = await instance.post(`/doc/${uidFile}`, {
      docToSave: file,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function publishV1(uidFile, file) {
  try {
    const response = await instance.post(`/v1/publish/${uidFile}`, {
      docToSave: file,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postAddMaisonEdition(body) {
  try {
    const response = await instance.post(`/maison/add`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postAddCollection(body) {
  try {
    const response = await instance.post(`/collection/add`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postAddSerie(body) {
  try {
    const response = await instance.post(`/serie/add`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postSerieGenre(idSerie, body) {
  try {
    const response = await instance.post(`/serie/${idSerie}/genre`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postReleaseSerie(idSerie) {
  try {
    return instance.post(`/serie/${idSerie}/release`);
  } catch (error) {
    console.error(error);
  }
}

export async function postAddEpisode(body, idSeason, epNumber) {
  try {
    const response = await instance.post(`/episode/add?idSeason=${idSeason}&epNum=${epNumber}`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postAddSaison(sumup, idSerie) {
  try {
    const response = await instance.post(`/${idSerie}/saison/add`, {
      sumup,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function dicoGPT(word, context) {
  try {
    const response = await instance.post(`/dicos/gpt`, {
      context,
      word,
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function postLogin(body) {
  try {
    const response = await axios.post(`${BASE_URL}/login`, body, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error('erre', error);
    if (error.response && error.response.data) return error.response.data;
    else return { error: true, msg: 'Erreur inconnue' };
  }
}

export async function postSaveManageApp(body, classification) {
  try {
    const response = await axios.post(`${BASE_URL}/library`, body, {
      withCredentials: true,
      params: { classification },
    });
    return response;
  } catch (error) {
    console.error('erre', error);
    return error.response;
  }
}

export async function postManageAccount(body) {
  try {
    const response = await axios.post(`${BASE_URL}/manage/account`, body, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error('erre', error);
    return error.response.data;
  }
}

export async function postGiftCode(body) {
  try {
    const response = await axios.post(`${BASE_URL}/manage/gift`, body, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error('erre', error);
    return error.response.data;
  }
}

export async function postSerieCode(body) {
  try {
    const response = await axios.post(`${BASE_URL}/manage/code/serie`, body, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('erre', error);
    return error.response.data;
  }
}


export async function stickers(body) {
  try {
    const response = await axios.post(`${BASE_URL}/compress`, body, {
      responseType: 'arraybuffer',
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error('erre', error);
    if (error.response && error.response.data) return error.response.data;
    else return { error: true, msg: 'Erreur inconnue' };
  }
}

export async function startTransition(body) {
  try {
    const response = await instance.post(`/edifice/transition`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "La transition n'a pas pu être lancée" };
  }
}

export async function startDeployCode(body) {
  try {
    const response = await instance.post(`/edifice/transition/code`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "La bascule de sélection n'a pas pu être lancée" };
  }
}

export async function startReloadClasses(body) {
  try {
    const response = await instance.post(`/edifice/transition/classes`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "Le rechargement des classes n'a pas pu être lancé" };
  }
}

export async function postCodeSeries(code, body) {
  try {
    const response = await instance.post(`/manage/webappcode/${encodeURIComponent(code)}/series`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "La modification n'a pas pu être appliquée" };
  }
}
